import FormFather from "@/Components/Form/FormFather";
import FormInputsNumeric from "@/Components/Form/FormInputs/FormInputsNumeric";
import FormInputsText from "@/Components/Form/FormInputs/FormInputsText";
import { useContextTicketProvider } from "@/Context/Ticket/ContextTicketCartProvider";
import { useTicketCart } from "@/Hooks/TicketCart/useTicketCart";
import type { MBuyCarCheckout } from "@/Models/MBuyCarCheckout/MBuyCarCheckout";
import React, { useState } from "react";

type Props = {
  createParchaseOrder: (formDatas: MBuyCarCheckout) => void;
  isLoading: boolean;
};

const FormClient = ({ createParchaseOrder, isLoading }: Props) => {
  const { ResponseBasket } = useContextTicketProvider();
  const { addTicketProduct } = useTicketCart();
  const TotalSalesPrice = addTicketProduct.reduce((acc, item) => {
    return acc + (item.price ?? 0) * (item.quantity ?? 0);
  }, 0);

  let Quantity = Number(
    addTicketProduct.reduce((acc, item) => acc + (item.quantity ?? 0), 0)
  );  

  //campos obligatorios
  const [formDataTicket, setFormDataTicket] = useState<MBuyCarCheckout>({
    postalCode: "27258",
    cColonia: "Ampliación La Rosita",
    address1: "Paseo Del Tecnológico",
    cStreetNumber: "353",
    interNumber: "",
    reference: "",
    city: "Torreón",
    stateCode: "Coahuila",
    firstName: "Ariel Mata",
    phone: "8711435934",
    //no estan en el formulario
    countryCode: "MX", //MX mexico
    companyName: "", //
    fullName: "",
    lastName: "",
    //basketId del back-end
    id: ResponseBasket?.basketId.toString() ?? "",
    //Importantes
    ipAddress: addTicketProduct[0]?.ipAddress ?? "",
    priceSale: TotalSalesPrice ?? 0, //totalSalesPrice ?? 0,
    Quantity: Quantity ?? 0, //quant ?? 0,
    email: "",
  });

  const checkEmptyOrFalseFields = () => {
    // Crear un array para guardar los campos vacíos o en false
    const emptyOrFalseFields = (
      Object.keys(formDataTicket) as (keyof MBuyCarCheckout)[]
    ).filter((key) => {
      const values = formDataTicket[key];
      return values === "";
    });

    return emptyOrFalseFields;
  };

  const headleOnChangue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setFormDataTicket({
      ...formDataTicket,
      [name]: value,
    });
    //const invalidFields = checkEmptyOrFalseFields();
    //const ActivoButton = invalidFields.length > 0 ? false : true;
    //setAvility(ActivoButton);
  };

  const handleSubmit = () => {
    createParchaseOrder(formDataTicket);
    //const invalidFields = checkEmptyOrFalseFields();
    //if (invalidFields.length === 0) {
    //headleOnClickFrom(formDataTicket);
    //}
  };

  return (
    <FormFather isLoading={isLoading} HanddleOnSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-6">
          <FormInputsNumeric
            TitleLabel={"* Código postal"}
            Name={"postalCode"}
            Placeholder={"Ingrese el código postal Ej: 1646"}
            Value={formDataTicket.postalCode}
            OnChange={headleOnChangue}
          />
        </div>
        <div className="col-sm-6">
          <FormInputsText
            TitleLabel={"* Colonia"}
            Name={"cColonia"}
            Placeholder={"Ingrese la colonia Ej: La Rosita"}
            Value={formDataTicket.cColonia}
            OnChange={headleOnChangue}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <FormInputsText
            TitleLabel={"* Calle"}
            Name={"address1"}
            Placeholder={"Ingrese la calle Ej: Paseo Del Tecnológico"}
            Value={formDataTicket.address1}
            OnChange={headleOnChangue}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <FormInputsNumeric
            TitleLabel={"* Número exterior"}
            Name={"cStreetNumber"}
            Placeholder={"Ingrese el número exterior Ej: 353"}
            Value={formDataTicket.cStreetNumber}
            OnChange={headleOnChangue}
          />
        </div>
        <div className="col-sm-6">
          <FormInputsNumeric
            TitleLabel={"Número interior"}
            Name={"interNumber"}
            Placeholder={"Ingrese el número interior Ej:  A-12"}
            Value={formDataTicket.interNumber}
            OnChange={headleOnChangue}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <FormInputsText
            TitleLabel={"Referencia"}
            Name={"reference"}
            Placeholder={"Ingrese una referencia Ej: Cerca de la tienda X"}
            Value={formDataTicket.reference}
            OnChange={headleOnChangue}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <FormInputsText
            TitleLabel={"* Municipio"}
            Name={"city"}
            Placeholder={"Ingrese el municipio Ej: Torreón"}
            Value={formDataTicket.city}
            OnChange={headleOnChangue}
          />
        </div>
        <div className="col-sm-6">
          <FormInputsText
            TitleLabel={"* Estado"}
            Name={"stateCode"}
            Placeholder={"Ingrese el municipio Ej: Torreón"}
            Value={formDataTicket.stateCode}
            OnChange={headleOnChangue}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <FormInputsText
            TitleLabel={"* Nombe de quien lo recibe"}
            Name={"firstName"}
            Placeholder={"Ingrese su Nombre Ej: Lucas"}
            Value={formDataTicket.firstName}
            OnChange={headleOnChangue}
          />
        </div>
        <div className="col-sm-6">
          <FormInputsNumeric
            TitleLabel={"Telefono celular"}
            Name={"phone"}
            Placeholder={"Ingrese su Télegono Ej: 048711435934"}
            Value={formDataTicket.phone}
            OnChange={headleOnChangue}
          />
        </div>
      </div>
    </FormFather>
  );
};

export default FormClient;
